import * as React from "react";
import {Grid, Card, Button, Icon, Form, Table} from "tabler-react";
import SiteWrapper from "../../../SiteWrapper.react";
import Crud_Catalogos from "../../../herramientas/Crud_Catalogos";
import TractosForm from "../../../Catalogos/Tractos/TractosForm";
import ModalLay from "../../../components/ModalLay/ModalLay";
import ModalCargaMasiva from "../../../components/CargaMasivaGenerico/ModalCargaMasiva";
import TableSkeleton from "../../../components/TableSkeleton/TableSkeleton";
import { tractosConfig } from "../../../components/CargaMasivaGenerico/configuraciones";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import "./TractosPage.css";

function getSessionData(key) {
  try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
}

function getfuntion (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") {
  Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
    switch (metodo) {
      case "get": 
      if (stateVar === "funcionalidades") {
        if (Array.isArray(returnVal)) {
          for( let item of returnVal){
            if(item.nombre == "Tracto"){ return true; }
          }
        }
        window.history.back();
        window.location.href = "403";
      }  break;
      default:
        break;
    }
  }).catch(err => { console.log("Error desconocido ...."+ err); })
}

class TractosPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenModals: false,
      tractos: [],
      tractosDeshabilitados: [],
      cargandoTractos: true,
      paginaActual: 1,
      registrosPorPagina: 10,
      tractoEditar: null,
      accionModal: "nuevo",
      busqueda: "",
      idTransportista: null,
      mostrarDeshabilitados: false,
      procesando: false,
      modalConfirmar: { visible: false, tracto: null, accion: null },
      showCargaMasiva: false,
      modalValidacionAbierto: false
    };
  }

  componentDidMount() {
    const currentUser = getSessionData("currentUser");
    if (!currentUser || !currentUser[0]?.perfil?.id) return;
    getfuntion("get", "", "", "funcionalidades/Administracion_Transportista/"+currentUser[0].perfil.id, "funcionalidades");
    this.obtenerIdTransportista();
  }

  obtenerIdTransportista = () => {
    const usuario = getSessionData("usuario");
    const currentUser = getSessionData("currentUser");
    if (usuario && currentUser) {
      const plataformasIds = [...new Set(currentUser.map(c => c.plataforma?.id).filter(Boolean))];
      const promesas = plataformasIds.map(idPlat =>
        Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", []).catch(() => [])
      );
      Promise.all(promesas).then((resultados) => {
        const todos = resultados.flat();
        const idsUnicos = [...new Set(todos.filter(t => t.idTransportista !== null).map(t => t.idTransportista))];
        if (idsUnicos.length > 0) {
          this.setState({ idTransportista: idsUnicos[0], idsTransportistas: idsUnicos }, () => {
            this.cargarTractos();
          });
        } else {
          this.setState({ cargandoTractos: false });
        }
      }).catch(err => {
        console.log("Error al cargar transportistas:", err);
        this.setState({ cargandoTractos: false });
      });
    } else {
      this.setState({ cargandoTractos: false });
    }
  };

  cargarTractos = () => {
    this.setState({ cargandoTractos: true });
    
    const { idsTransportistas } = this.state;
    
    if (!idsTransportistas || idsTransportistas.length === 0) {
      this.setState({ cargandoTractos: false });
      return;
    }
    
    // Obtener relaciones (con estatus) y datos de unidades en paralelo por cada transportista
    Promise.all(idsTransportistas.map(id =>
      Promise.all([
        Crud_Catalogos("transportistas_unidades_ter_nav/id_transportista/" + id, "", "get", "", [], "", "", "", []).catch(() => []),
        Crud_Catalogos("unidadTerNav/idTransportista/" + id, "", "get", "", [], "", "", "", []).catch(() => [])
      ])
    )).then((resultados) => {
      // Mapear estatus desde las relaciones
      const unidadEstatus = new Map();
      resultados.forEach(([relaciones]) => {
        relaciones.forEach(r => {
          const prev = unidadEstatus.get(r.idUnidad);
          if (!prev || r.estatus) {
            unidadEstatus.set(r.idUnidad, r.estatus !== false);
          }
        });
      });

      // Deduplicar unidades
      const unidadesMap = new Map();
      resultados.forEach(([, unidades]) => {
        unidades.forEach(u => {
          if (!unidadesMap.has(u.id)) unidadesMap.set(u.id, u);
        });
      });

      const tiposTracto = [1, 5, 25, 28];
      const tractosValidos = [...unidadesMap.values()].filter(u => tiposTracto.includes(u.idUnidadTipo?.id));
      const activos = tractosValidos.filter(u => unidadEstatus.get(u.id) !== false);
      const deshabilitados = tractosValidos.filter(u => unidadEstatus.get(u.id) === false);
      activos.sort((a, b) => b.id - a.id);
      deshabilitados.sort((a, b) => b.id - a.id);
      this.setState({ tractos: activos, tractosDeshabilitados: deshabilitados, cargandoTractos: false });
    }).catch(err => {
      console.log("Error al cargar tractos:", err);
      this.setState({ cargandoTractos: false });
    });
  };

  cambiarPagina = (numeroPagina) => {
    this.setState({ paginaActual: numeroPagina });
  };

  hiddenmodal = () => {
    const estabAbierto = this.state.hiddenModals;
    this.setState({ 
      hiddenModals: !this.state.hiddenModals,
      tractoEditar: null,
      accionModal: "nuevo",
      paginaActual: 1
    });
    if (estabAbierto) {
      this.cargarTractos();
    }
  };

  abrirModalEditar = (tracto) => {
    this.setState({
      tractoEditar: tracto,
      accionModal: "editar"
    }, () => {
      this.setState({ hiddenModals: true });
    });
  };

  abrirModalNuevo = () => {
    this.setState({
      tractoEditar: null,
      accionModal: "nuevo",
      hiddenModals: true
    });
  };

  filtrarTractos = () => {
    const { tractos, tractosDeshabilitados, busqueda, mostrarDeshabilitados } = this.state;
    
    const lista = mostrarDeshabilitados
      ? tractosDeshabilitados.map(t => ({...t, _activo: false}))
      : tractos.map(t => ({...t, _activo: true}));

    if (!busqueda.trim()) return lista;

    const termino = busqueda.toLowerCase();
    return lista.filter(trc => {
      const placa = (trc.placa || '').toLowerCase();
      const economico = (trc.economico || '').toLowerCase();
      const marca = (trc.idUnidadMarca?.nombre || '').toLowerCase();
      return placa.includes(termino) || economico.includes(termino) || marca.includes(termino);
    });
  };

  handleBusquedaChange = (e) => {
    this.setState({ busqueda: e.target.value, paginaActual: 1 });
  };

  abrirModalConfirmar = (tracto, accion) => {
    this.setState({ modalConfirmar: { visible: true, tracto, accion } });
  };

  exportarExcel = () => {
    const { tractos, tractosDeshabilitados, mostrarDeshabilitados } = this.state;
    const lista = mostrarDeshabilitados ? tractosDeshabilitados : tractos;
    const data = lista.map(trc => ({
      "Placa": trc.placa || '',
      "Económico": trc.economico || '',
      "Marca": trc.idUnidadMarca?.nombre || '',
      "Color": trc.color || '',
      "Modelo": trc.modelo || '',
      "Estado": mostrarDeshabilitados ? 'Deshabilitado' : 'Activo'
    }));
    if (data.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = Object.keys(data[0]).map(key => ({ wch: Math.max(key.length, 12) * 1.25 }));
    const wb = { Sheets: { 'Tractos': ws }, SheetNames: ['Tractos'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const usuario = getSessionData("usuario");
    const nombreUsuario = usuario ? (usuario.nombre || usuario.username || 'usuario') : 'usuario';
    FileSaver.saveAs(blob, `Tractos-${nombreUsuario}.xlsx`);
  };

  cerrarModalConfirmar = () => {
    this.setState({ modalConfirmar: { visible: false, tracto: null, accion: null } });
  };

  ejecutarAccionConfirmada = () => {
    const { tracto, accion } = this.state.modalConfirmar;
    const { idsTransportistas } = this.state;

    if (!idsTransportistas || idsTransportistas.length === 0) {
      console.error("No se encontraron transportistas para ejecutar la acción");
      this.cerrarModalConfirmar();
      return;
    }

    const ruta = accion === "deshabilitar" ? "desactivar" : "activar";

    this.setState({ procesando: true });
    this.cerrarModalConfirmar();

    // Ejecutar en todos los transportistas asociados
    const promesas = idsTransportistas.map(idTransp =>
      Crud_Catalogos(
        "transportistas_unidades_ter_nav/" + ruta + "/" + tracto.id + "/" + idTransp,
        "", "put", "", { estatus: accion !== "deshabilitar" }, "", "", "", []
      ).catch(err => {
        console.error("Error al " + accion + " tracto " + tracto.id + " con transportista " + idTransp + ":", err);
        return null;
      })
    );

    Promise.all(promesas)
      .then(() => this.cargarTractos())
      .finally(() => this.setState({ procesando: false }));
  };

  render() {
    const { tractos, tractosDeshabilitados, cargandoTractos, paginaActual, registrosPorPagina, tractoEditar, accionModal, busqueda, mostrarDeshabilitados } = this.state;

    const tractosFiltrados = this.filtrarTractos();
    const indiceUltimo = paginaActual * registrosPorPagina;
    const indicePrimero = indiceUltimo - registrosPorPagina;
    const tractosPaginados = tractosFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(tractosFiltrados.length / registrosPorPagina);

    return (
      <SiteWrapper>
        <Grid.Row>
          <Grid.Col width={12}>
            <Card>
              <Card.Header>
                <Card.Title>Catálogo de Tractos</Card.Title>
                <Card.Options>
                  <div onClick={this.exportarExcel} style={{ marginRight: '10px' }}>
                    <Button size="sm" color="purple">
                      <Icon name="download" /> Exportar
                    </Button>
                  </div>
                  <div onClick={() => this.setState({ showCargaMasiva: true })} style={{ marginRight: '10px' }}>
                    <Button size="sm" color="success">
                      <Icon name="upload" /> Carga Masiva
                    </Button>
                  </div>
                  
                  <div onClick={this.abrirModalNuevo}>
                    <Button size="sm" color="primary">
                      <Icon name="plus" /> Nuevo
                    </Button>
                  </div>
                  <ModalLay
                    tamanio="70%"
                    title={accionModal === "nuevo" ? "Nuevo Tracto" : "Editar Tracto"}
                    name={<span style={{display: 'none'}}></span>}
                    hiddenModal={this.state.hiddenModals}
                    Fclose={this.hiddenmodal}
                    formulario={TractosForm}
                    datosForm={{
                      accion: accionModal,
                      elementos: tractoEditar,
                      cerrarModal: this.hiddenmodal,
                      idTransportista: this.state.idTransportista,
                      multiPlataforma: true
                    }}
                  />
                </Card.Options>
              </Card.Header>
              <Card.Body>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                  <div style={{ maxWidth: '400px', flex: 1 }}>
                    <Form.Input
                      icon="search"
                      placeholder="Buscar tracto..."
                      value={busqueda}
                      onChange={this.handleBusquedaChange}
                      disabled={cargandoTractos}
                    />
                  </div>
                  <div className="switch-container">
                    <label className="switch-toggle">
                      <input
                        type="checkbox"
                        checked={mostrarDeshabilitados}
                        onChange={() => this.setState({ mostrarDeshabilitados: !mostrarDeshabilitados, paginaActual: 1 })}
                      />
                      <span className="switch-slider"></span>
                    </label>
                    <span style={{ fontSize: '14px', color: '#6c757d' }}>
                      Mostrar deshabilitados {tractosDeshabilitados.length > 0 && <span className="badge-deshabilitado">{tractosDeshabilitados.length}</span>}
                    </span>
                  </div>
                </div>

                {cargandoTractos ? (
                  <TableSkeleton
                    title="Tractos"
                    headers={['Placa', 'Económico', 'Marca', 'Color', 'Modelo', 'Editar']}
                    isLoading={cargandoTractos}
                  />
                ) : (
                  <>
                    <div style={{ 
                      textAlign: 'center', 
                      fontSize: '32px', 
                      fontWeight: 'bold', 
                      marginBottom: '30px',
                      color: '#467fcf'
                    }}>
                      Total de Tractos: {tractos.length}
                    </div>
                    
                    {tractosFiltrados.length === 0 && !mostrarDeshabilitados && tractos.length === 0 ? (
                  <div style={{padding: '40px', textAlign: 'center'}}>
                    <Icon name="truck" style={{fontSize: '48px', color: '#ccc'}} />
                    <h3>No hay tractos registrados</h3>
                    <p>Usa el botón "Nuevo" para agregar tractos</p>
                  </div>
                ) : tractosFiltrados.length === 0 ? (
                  <div style={{padding: '40px', textAlign: 'center'}}>
                    <Icon name="search" style={{fontSize: '48px', color: '#ccc'}} />
                    <h3>No se encontraron tractos</h3>
                    <p>Intenta con otro término de búsqueda</p>
                  </div>
                ) : (
                  <div className="tractos-table-container">
                    <Table className="tractos-table" responsive>
                      <Table.Header>
                        <Table.Row>
                          <Table.ColHeader>Placa</Table.ColHeader>
                          <Table.ColHeader>Económico</Table.ColHeader>
                          <Table.ColHeader>Marca</Table.ColHeader>
                          <Table.ColHeader>Color</Table.ColHeader>
                          <Table.ColHeader>Modelo</Table.ColHeader>
                          {mostrarDeshabilitados && <Table.ColHeader>Estado</Table.ColHeader>}
                          <Table.ColHeader>Acciones</Table.ColHeader>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {tractosPaginados.map((tracto) => (
                          <Table.Row key={tracto.id} className={!tracto._activo ? 'fila-deshabilitada' : ''}>
                            <Table.Col>
                              <div style={{ fontWeight: '600' }}>
                                {tracto.placa || '-'}
                              </div>
                            </Table.Col>
                            <Table.Col>{tracto.economico || '-'}</Table.Col>
                            <Table.Col>{tracto.idUnidadMarca?.nombre || '-'}</Table.Col>
                            <Table.Col>{tracto.color || '-'}</Table.Col>
                            <Table.Col>{tracto.modelo || '-'}</Table.Col>
                            {mostrarDeshabilitados && (
                              <Table.Col>
                                <span style={{
                                  padding: '3px 10px',
                                  borderRadius: '12px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: 'white',
                                  backgroundColor: tracto._activo ? '#5eba00' : '#dc3545'
                                }}>
                                  {tracto._activo ? 'Activo' : 'Deshabilitado'}
                                </span>
                              </Table.Col>
                            )}
                            <Table.Col>
                              {tracto._activo ? (
                                <>
                                  <Button 
                                    size="sm" 
                                    color="primary" 
                                    icon="edit"
                                    onClick={() => this.abrirModalEditar(tracto)}
                                  >
                                    Editar
                                  </Button>
                                  {' '}
                                  <Button 
                                    size="sm" 
                                    color="danger" 
                                    icon="x"
                                    disabled={this.state.procesando}
                                    onClick={() => this.abrirModalConfirmar(tracto, "deshabilitar")}
                                  >
                                    Deshabilitar
                                  </Button>
                                </>
                              ) : (
                                <Button 
                                  size="sm" 
                                  color="success" 
                                  icon="check"
                                  disabled={this.state.procesando}
                                  onClick={() => this.abrirModalConfirmar(tracto, "habilitar")}
                                >
                                  Habilitar
                                </Button>
                              )}
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginTop: '20px',
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px'
                    }}>
                      <div style={{ fontSize: '14px', color: '#6c757d' }}>
                        Mostrando {indicePrimero + 1} - {Math.min(indiceUltimo, tractosFiltrados.length)} de {tractosFiltrados.length} tractos
                      </div>
                      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                        <Button
                          size="sm"
                          color="secondary"
                          disabled={paginaActual === 1}
                          onClick={() => this.cambiarPagina(paginaActual - 1)}
                        >
                          <Icon name="chevron-left" />
                        </Button>
                        
                        <span style={{ 
                          padding: '0 10px', 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#495057'
                        }}>
                          {paginaActual} / {totalPaginas}
                        </span>
                        
                        <Button
                          size="sm"
                          color="secondary"
                          disabled={paginaActual >= totalPaginas || totalPaginas === 0}
                          onClick={() => this.cambiarPagina(paginaActual + 1)}
                        >
                          <Icon name="chevron-right" />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                </>
                )}
              </Card.Body>

              {/* Modal de confirmación */}
              {this.state.modalConfirmar.visible && (
                <div style={{
                  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                  justifyContent: 'center', alignItems: 'center', zIndex: 9999
                }}>
                  <div style={{
                    backgroundColor: 'white', borderRadius: '12px', padding: '30px',
                    maxWidth: '400px', width: '90%', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                  }}>
                    <Icon 
                      name={this.state.modalConfirmar.accion === "deshabilitar" ? "alert-triangle" : "check-circle"} 
                      style={{ 
                        fontSize: '48px', 
                        color: this.state.modalConfirmar.accion === "deshabilitar" ? '#dc3545' : '#5eba00',
                        marginBottom: '15px'
                      }} 
                    />
                    <h4 style={{ marginBottom: '10px' }}>
                      {this.state.modalConfirmar.accion === "deshabilitar" ? "Deshabilitar Tracto" : "Habilitar Tracto"}
                    </h4>
                    <p style={{ color: '#6c757d', marginBottom: '25px' }}>
                      ¿Deseas {this.state.modalConfirmar.accion} este tracto?
                    </p>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <Button size="sm" color="secondary" onClick={this.cerrarModalConfirmar}>
                        Cancelar
                      </Button>
                      <Button 
                        size="sm" 
                        color={this.state.modalConfirmar.accion === "deshabilitar" ? "danger" : "success"} 
                        onClick={this.ejecutarAccionConfirmada}
                      >
                        {this.state.modalConfirmar.accion === "deshabilitar" ? "Deshabilitar" : "Habilitar"}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </Grid.Col>
        </Grid.Row>
        
        <ModalCargaMasiva
          isOpen={this.state.showCargaMasiva}
          onClose={() => this.setState({ showCargaMasiva: false })}
          title="Carga Masiva de Tractos"
          subtitle="Importa múltiples tractos desde un archivo Excel"
          config={tractosConfig(this.state.idTransportista)}
          onDataLoaded={() => this.cargarTractos()}
        />
      </SiteWrapper>
    );
  }
}

export default TractosPage;
